import React, { useState, useRef, useEffect } from 'react'
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';

import AdapterMoment from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { useFormContext } from 'react-hook-form'
import PropTypes from "prop-types";
import moments from 'moment'
import { FormHelperText, Stack } from "@mui/material"
import EventIcon from '@mui/icons-material/Event';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import moment from 'moment';
// import 'moment/locale/th'
// import 'moment/locale/en-gb'


const localeMap = {
    en: moment.locale("en-gb"),
    th: moment.locale("th"),
};


export default function DateRangePicker({
    minDate, maxDate, name, label, calendarsCount, lableEnd, require, disabled, format, onChange
}) {
    const {
        register,
        setValue,
        getValues,
        watch,
        formState: { errors },
    } = useFormContext();

    const ReplaceThFormat = (text) => {
        if(currentLanguage() == "th")
        {
            return text.toLowerCase().replaceAll("d", "ว").replaceAll("m", "ด").replaceAll("y", "ป");

        }
        else
        {
            return text.toLowerCase();
        }
    }

    const formatDefalut = format;
    const maskMap = {
        en: formatDefalut,
        th: ReplaceThFormat(formatDefalut),
    };

    const [locale, setLocale] = React.useState<keyof typeof maskMap>("th");

    const [objCheckReplace] = useState(() => {
        let objReturn = { isReplaceYear: false, indexArr: 0, splitText: "" };
        var formatLower = formatDefalut.toLowerCase();
        if (formatLower.includes("yyyy")) {
            var splitText = (formatDefalut.substr(formatLower.indexOf("yyyy") - 1, 1)).toLowerCase();
            if (splitText !== "y") {
                objReturn.splitText = splitText;
                objReturn.indexArr = formatLower.split(splitText).findIndex((e) => e === "yyyy");
            }
            objReturn.isReplaceYear = true;
        }
        return objReturn;
    });

    const [stateError, setStateError] = useState([null, null]);
    const [openPicker, setOpenPicker] = useState(false);
    const inpRef = useRef(null)
    useEffect(() => {
        setValue(`${name}`, watch(name) || [null, null])
    }, [])

    // useEffect(() => {
    //     let sLang : 'th' | 'en' = currentLanguage() == "th" ? "th" : "en";
    //     setLocale(sLang)
    // }, [])

    return (
        <>
            <LocalizationProvider
                locale={localeMap[locale]}
            // dateAdapter={CustomAdapter}
                // dateAdapter={AdapterMoment}
                dateAdapter={locale === 'th' ? CustomAdapter : AdapterMoment}
            >
                <MobileDateRangePicker
                    {...register(name)}
                    value={watch(name) || [null, null]}
                    onChange={(newValue, key) => {
                        setValue(`${name}`, newValue, { shouldValidate: true });
                    }}
                    onError={(reason, value) => {
                        setStateError(reason)
                    }}
                    clearable
                    components={{
                        OpenPickerIcon: EventIcon
                    }}
                    disableCloseOnSelect={false}
                    showToolbar={false}
                    inputFormat="DD/MM/YYYY"
                    minDate={minDate || null}
                    maxDate={maxDate || null}
                    calendars={calendarsCount}
                    inputRef={inpRef}
                    open={openPicker}
                    onClose={() => setOpenPicker(false)}
                    renderInput={(startProps, endProps) => {
                        startProps.inputProps.placeholder = maskMap[locale];
                        endProps.inputProps.placeholder = maskMap[locale];
                        if (locale === "th") {
                            if (startProps.inputProps.value && objCheckReplace.isReplaceYear && startProps.inputProps.value.length == 10) {
                                let year = objCheckReplace.splitText ? startProps.inputProps.value.split(objCheckReplace.splitText)[objCheckReplace.indexArr] : startProps.inputProps.value.substr(0, 4);
                                let addyear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;

                                startProps.inputProps.value = startProps.inputProps.value.replaceAll(`${year}`, `${addyear}`);   //ปิดเพราะทำให้พิมพ์แล้ว error
                            } else if (format === "YYYY" && startProps.inputProps.value && objCheckReplace.isReplaceYear && startProps.inputProps.value.length == 4) {
                                let addyear = parseInt(startProps.inputProps.value) > 2500 ? parseInt(startProps.inputProps.value) : parseInt(startProps.inputProps.value) + 543;
                                startProps.inputProps.value = addyear;
                            }

                            if (endProps.inputProps.value && objCheckReplace.isReplaceYear && endProps.inputProps.value.length == 10) {
                                let year = objCheckReplace.splitText ? endProps.inputProps.value.split(objCheckReplace.splitText)[objCheckReplace.indexArr] : endProps.inputProps.value.substr(0, 4);
                                let addyear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;

                                endProps.inputProps.value = endProps.inputProps.value.replaceAll(`${year}`, `${addyear}`);   //ปิดเพราะทำให้พิมพ์แล้ว error
                            } else if (format === "YYYY" && endProps.inputProps.value && objCheckReplace.isReplaceYear && endProps.inputProps.value.length == 4) {
                                let addyear = parseInt(endProps.inputProps.value) > 2500 ? parseInt(endProps.inputProps.value) : parseInt(endProps.inputProps.value) + 543;
                                endProps.inputProps.value = addyear;
                            }
                        }
                        return (
                            <React.Fragment>
                                <Stack style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <TextField
                                        disabled
                                        size={"small"}
                                        inputRef={register(name).ref[0]}
                                        {...startProps}
                                        error={errors && errors[name]}
                                        fullWidth
                                        required={require}
                                        label={label}
                                        onClick={() => setOpenPicker(true)}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end" >
                                                    <IconButton
                                                        onClick={() => setOpenPicker(true)}
                                                        style={{
                                                            marginRight: '-15px'
                                                        }}
                                                    >
                                                        <EventIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            "label.MuiInputLabel-shrink": {
                                                backgroundColor: "rgba(255,255,255,0.95)",
                                                top: "0px",
                                            },
                                            ".MuiInputLabel-outlined": {
                                                top: "0px",
                                            },
                                            ".MuiInputLabel-asterisk": {
                                                color: "red"
                                            }
                                        }}
                                    />
                                    <FormHelperText sx={{ color: "red" }} >{stateError[0]}</FormHelperText>
                                </Stack>
                                <Box sx={{ mx: 1 }}> - </Box>
                                <Stack style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                                    <TextField
                                        disabled
                                        size={"small"}
                                        inputRef={register(name).ref[1]}
                                        {...endProps}
                                        error={errors && errors[name]}
                                        onClick={() => setOpenPicker(true)}
                                        required={require}
                                        label={lableEnd}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setOpenPicker(true)}
                                                        style={{
                                                            marginRight: '-15px'
                                                        }}
                                                    >
                                                        <EventIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            "label.MuiInputLabel-shrink": {
                                                backgroundColor: "rgba(255,255,255,0.95)",
                                                top: "0px",
                                            },
                                            ".MuiInputLabel-outlined": {
                                                top: "0px",
                                            },
                                            ".MuiInputLabel-asterisk": {
                                                color: "red"
                                            }
                                        }}
                                    />
                                    <FormHelperText sx={{ color: "red" }} >{stateError[1]}</FormHelperText>
                                </Stack>
                            </React.Fragment>
                        )
                    }
                    }
                />
                {errors && errors[name] ? (
                    <FormHelperText sx={{ color: "red" }}>
                        {errors[name].message}
                    </FormHelperText>
                ) : null}
            </LocalizationProvider>
        </>
    )
}

DateRangePicker.defaultProps = {
    label: "",
    lableEnd: "",
    calendarsCount: 1,
    disabled: false,
    format: "DD/MM/YYYY",
};

DateRangePicker.propTypes = {
    name: PropTypes.string.isRequired,
    minDate: PropTypes.instanceOf(moments.prototype),
    maxDate: PropTypes.instanceOf(moments.prototype),
    label: PropTypes.string,
    require: PropTypes.bool,
    calendarsCount: PropTypes.number,
    lableEnd: PropTypes.string,
    disabled: PropTypes.bool,
    format: PropTypes.string,
    onChange: PropTypes.func,
};

class CustomAdapter extends AdapterMoment {
    // REF : https://th-samranrit0193.medium.com/reactjs-materialui-buddhist-era-%E0%B8%9B%E0%B8%B5-%E0%B8%9E-%E0%B8%A8-1f293af00382
    constructor({ locale, formats, instance }) {
        super({ locale, formats, instance });
    }

    renderLabel(moment, format) {
        switch (format) {
            case "year":
                var checkYear = this.locale === "th" ? (parseInt(moment.format('YYYY')) + 543).toString() : parseInt(moment.format('YYYY'));
                return moment.format(checkYear);
            case "month":
                return moment.format("MMMM");
            case "dayOfMonth":
                return moment.format("D");
            default:
                return moment.format(format);
        }
    }

    format = (date, formatKey) => {
        return this.renderLabel(date, formatKey);
    };
}